/*
 * @author: chenshoyu
 * @Date: 2021-11-17 17:46:16
 */
/**
 * 搜索框state同步动作定义
 * @author VenDream
 * @since 18/06/06
 */

import { get } from '@fe/common/lib/ajax';
import ACTIONS from 'constants/action.json5';

const apis = {
  mainfigure: '/api/store/template/getBannerList',
  hotwords: '/api/store/template/hotwords',
};

// 免费模板-子首页-顶部 banner类型
const BANNERTYPE = 10;
// 获取模板主图
export function getMainFigure() {
  return async dispatch => {
    try {
      const mainfigure = await get(apis.mainfigure, { bannerType: BANNERTYPE });
      if (mainfigure.length > 0) {
        dispatch({
          type: ACTIONS.SET_MAIN_FIGURE,
          mainfigure: mainfigure[0].imageUrl,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
}

// 设置搜索关键词
export function setSearchKeywords(keywords) {
  return {
    type: ACTIONS.SET_SEARCH_KEYWORDS,
    keywords,
  };
}

// 获取搜索热词
export function getSearchHotwords() {
  return async dispatch => {
    try {
      const hotwords = await get(apis.hotwords);
      if (hotwords) {
        dispatch({
          type: ACTIONS.SET_SEARCH_HOTWORDS,
          hotwords,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
}

// 设置搜索作品类型
export function setSearchCategory(category) {
  return {
    type: ACTIONS.SET_SEARCH_CATEGORY,
    category,
  };
}

//清除单个搜索条件
export function clearFilter(e, filter) {
  return {
    type: ACTIONS.CLEAR_SEARCH_FILTER,
    filter,
    e,
  };
}
//增加单个搜索条件
export function addFilter(filter) {
  return {
    type: ACTIONS.ADD_SEARCH_FILTER,
    filter: [filter],
  };
}
